var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339.19,
    height: 309.237,
    viewBox: "0 0 339.19 309.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7493",
    "data-name": "Group 7493",
    transform: "translate(-782.647 -350.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M175,365.3s.417,57.594,53.838,77.209c0,0,41.735,17.946,83.47-24.624,0,0,40.9,41.317,79.3-11.268,0,0,32.97,17.111,52.168-18.781,0,0,15.442-30.884-10.016-50.082,0,0,15.859-27.962.835-58.011,0,0-10.016-22.954-35.475-29.214,0,0-2.087-56.342-53.421-76.375,0,0-76.792-29.632-107.676,56.759,0,0-54.255-20.033-75.123,45.491,0,0-45.908,6.678-35.892,57.594C127,334,135.769,369.47,175,365.3Z",
    transform: "translate(673.426 213.74)",
    fill: "#c2eed3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(306.84 -192.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7192",
    "data-name": "Path 7192",
    d: "M1163.483,697.142l3.229,20.253,6.823-27s-9.563-4.641-9.984-2.954S1163.483,697.142,1163.483,697.142Z",
    transform: "translate(-537.324 -112.599)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7193",
    "data-name": "Path 7193",
    d: "M1312.446,932.69,1315.4,967.7l-30.9-1.475,3.563-31.007Z",
    transform: "translate(-632.01 -304.556)",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7194",
    "data-name": "Path 7194",
    d: "M1293.05,949.967l1.693-14.745,24.382-2.532,1.022,12.126C1315.3,949.646,1306.585,954.654,1293.05,949.967Z",
    transform: "translate(-638.692 -304.556)",
    fill: "#f99893"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7490",
    "data-name": "Group 7490",
    transform: "translate(623.344 563.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7195",
    "data-name": "Path 7195",
    d: "M1163.166,807.648c1.857,3.843.872,8.162-2.2,9.648s-7.072-.424-8.929-4.267-.872-8.162,2.2-9.648S1161.309,803.807,1163.166,807.648Z",
    transform: "translate(-1151.096 -766.722)",
    fill: "#f99893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7196",
    "data-name": "Path 7196",
    d: "M1184.568,696.079a61.108,61.108,0,0,1-4.26-14.951c-.162-1-.382-1.992-.618-2.978a33.014,33.014,0,1,1,65.039-9.84,7.136,7.136,0,0,1,6.382-.907c4.02,1.5,5.761,6.788,3.889,11.813s-6.651,7.885-10.673,6.386a6.245,6.245,0,0,1-1.534-.839c-.62,16.235-13.048,29.525-28.918,30.268a29.619,29.619,0,0,1-20.585-7.081C1189.7,705.314,1186.309,700.178,1184.568,696.079Z",
    transform: "translate(-1172.721 -637.388)",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7197",
    "data-name": "Path 7197",
    d: "M1287.016,789.14c-.063,1.892-.079,3.738-.175,5.547-.111,1.674-.295,4.077-1.337,5.353a4.021,4.021,0,0,0-.992,2.445,3.9,3.9,0,0,0,1.442,3.057,6.369,6.369,0,0,0,5.681,1.108,7.852,7.852,0,0,1-4.645-2.167,2.258,2.258,0,0,1-.052-3.212,6.137,6.137,0,0,0,1.394-3.7,15.406,15.406,0,0,0-.013-2.91A19.867,19.867,0,0,0,1287.016,789.14Z",
    transform: "translate(-1255.362 -755.985)",
    fill: "#f99893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7198",
    "data-name": "Path 7198",
    d: "M1346.089,789.791a2.882,2.882,0,1,0,2.744-3.013A2.882,2.882,0,0,0,1346.089,789.791Z",
    transform: "translate(-1303.484 -754.137)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7199",
    "data-name": "Path 7199",
    d: "M1233.289,802.511a2.882,2.882,0,1,0,2.744-3.013A2.882,2.882,0,0,0,1233.289,802.511Z",
    transform: "translate(-1215.329 -764.078)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7200",
    "data-name": "Path 7200",
    d: "M1290.445,895.746c-2.934-2.556-10.634-3.2-10.634-3.2s-7.624-1.083-11.111,1.066a14.551,14.551,0,0,1,11.3-3.631A17.088,17.088,0,0,1,1290.445,895.746Z",
    transform: "translate(-1243.006 -834.725)",
    fill: "#f99893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7201",
    "data-name": "Path 7201",
    d: "M1329.55,758.565c4.062-1.254,6.36-1.326,8.217-1.1,4.048.544,6.327,2.333,7.743,2.954a9.643,9.643,0,0,0-15.96-1.855Z",
    transform: "translate(-1290.562 -729.417)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7202",
    "data-name": "Path 7202",
    d: "M1216.726,769.79a9.642,9.642,0,0,0-15.3,4.918c1.271-.885,3.153-3.081,7.022-4.4C1210.224,769.727,1212.489,769.347,1216.726,769.79Z",
    transform: "translate(-1190.433 -739.214)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7203",
    "data-name": "Path 7203",
    d: "M984.745,1019.142s-29.077,3.692-36.462,9.692-42.923,94.154-42.923,94.154L934.9,1157.6l62.769.461s47.076,25.385,76.614,1.385,14.308-107.538-2.768-125.536-47.539-17.537-47.539-17.537S996.282,1035.757,984.745,1019.142Z",
    transform: "translate(-335.704 -369.957)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7204",
    "data-name": "Path 7204",
    d: "M1516.639,1229.73a122.206,122.206,0,0,0-2.13,14.573c-.251,2.445-.358,4.9-.5,7.356-.074,2.458-.131,4.918-.1,7.382a96.874,96.874,0,0,0,1.212,14.732,48.42,48.42,0,0,0,4.284,14.109,72.381,72.381,0,0,1-2.816-14.311c-.535-4.826-.721-9.694-.782-14.557-.1-4.865.018-9.742.173-14.621Q1516.242,1237.076,1516.639,1229.73Z",
    transform: "translate(-811.292 -536.699)",
    fill: "#2eab5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7205",
    "data-name": "Path 7205",
    d: "M1041.559,1214.94c-1.328,7.151-2.735,14.273-4.164,21.385-1.459,7.105-2.971,14.2-4.691,21.232-1.7,7.037-3.589,14.031-5.875,20.885a102.084,102.084,0,0,1-3.922,10.089,38.831,38.831,0,0,1-5.578,9.255,35.357,35.357,0,0,0,6.41-8.84,82.956,82.956,0,0,0,4.483-10c1.307-3.413,2.427-6.889,3.489-10.378,1.025-3.5,1.962-7.024,2.836-10.561.835-3.546,1.634-7.1,2.351-10.668.693-3.574,1.374-7.149,1.947-10.743C1040.034,1229.412,1040.956,1222.191,1041.559,1214.94Z",
    transform: "translate(-423.211 -525.14)",
    fill: "#2eab5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7206",
    "data-name": "Path 7206",
    d: "M1061.341,1555.511c.186-1.462,11.278-3.094,15.355-3.3,3.089-.159,23.567-.843,30.532-1.158l-.511,1.792.1,7.909,1.145,5.241c-6.111.387-21.051.972-24.162,1.586-4.156.822-11.363,3.955-11.363,3.955s-3-.682.813-2.325a18.24,18.24,0,0,0,6.113-4.381c.522-.585-.044-1.625-.424-1.527-10.371,2.718-11.439,3.168-11.439,3.168s-12.191-.068-.07-2.807c7.266-1.643,9.869-2.6,10.518-3.413.275-.347-.216-1.529-.66-1.556-6.294-.389-17.594,1.842-14.5.38,2.523-1.193,10.472-2.5,13.563-2.993.19-.031.5-1.182-.347-1.252C1070.015,1554.327,1061.169,1556.87,1061.341,1555.511Z",
    transform: "translate(-457.605 -787.817)",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7207",
    "data-name": "Path 7207",
    d: "M1322.15,1492.223c-2.545.607-5.128,1.049-7.684,1.588q-7.718,1.406-15.484,2.482c-5.182.679-10.373,1.307-15.575,1.809-5.182.513-10.454.955-15.584,1.243l-.69.039-.151.6a42.093,42.093,0,0,0-.946,5.176,41.369,41.369,0,0,0-.306,5.228,33.936,33.936,0,0,0,.452,5.233,24.154,24.154,0,0,0,1.518,5.047l.059.14.111.074,5.7,3.823c1.9,1.276,3.806,2.543,5.731,3.784q-2.681-2.15-5.4-4.236l-5.3-4.094a23.166,23.166,0,0,1-1.156-4.739,33.469,33.469,0,0,1-.245-5.021,46.741,46.741,0,0,1,.456-5.025,41.878,41.878,0,0,1,.852-4.3c2.46-.081,4.818-.24,7.234-.417,2.622-.194,5.241-.4,7.854-.677,5.228-.54,10.446-1.193,15.637-2.021s10.354-1.851,15.468-3.059c2.548-.651,5.1-1.278,7.607-2.071,2.528-.71,5.008-1.6,7.476-2.475C1327.232,1490.973,1324.715,1491.685,1322.15,1492.223Z",
    transform: "translate(-617.341 -740.379)",
    fill: "#2eab5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7208",
    "data-name": "Path 7208",
    d: "M482.028,1302.61h98.921a7.48,7.48,0,0,1,6.919,4.643l30.29,73.934H672.85a2.767,2.767,0,0,1,2.768,2.768h0a2.767,2.767,0,0,1-2.768,2.768h-157.9a7.4,7.4,0,0,1-6.753-4.374l-31.841-70.984A6.213,6.213,0,0,1,482.028,1302.61Z",
    transform: "translate(0 -593.656)",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7209",
    "data-name": "Path 7209",
    d: "M1139.436,565.382s-9.694.312.478-7.885,37.482-17.808,54.989-8.564c0,0,3.5-7.444,8.56-5.665s-3.29,6.9-3.29,6.9,6.463-.208,8.433,2.963c1.457,2.344-2.5,2.447-4.662,2.34,3.679.625,17.782,9.532,10.7,37.97-2.517-.553-16.854-21.341-16.854-21.341s-32.785,18.215-29.543,3.732c0,0-33.967,21.2-29.147,3.688C1139.106,579.514,1125.974,580.475,1139.436,565.382Z",
    transform: "translate(-513.896)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7210",
    "data-name": "Path 7210",
    d: "M1431.111,651.617a6.207,6.207,0,0,0-5.635,1.363c-2.919,2.316-2.6,10.459-2.6,10.459s-13.937,8.986-12.469-29.042c1.564-40.458,11.625,3.244,11.625,3.244Z",
    transform: "translate(-730.328 -58.009)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3129",
    "data-name": "Ellipse 3129",
    cx: 6.251,
    cy: 8.551,
    rx: 6.251,
    ry: 8.551,
    transform: "translate(529.365 744.121) rotate(-11.905)",
    fill: "#fff",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 250,
    y2: 1,
    transform: "translate(804.5 600.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    transform: "translate(879 457)",
    fill: "#fff",
    stroke: "#e3393c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7211",
    "data-name": "Path 7211",
    d: "M7.29,7.29a1.819,1.819,0,0,0,0,2.572l6.43,6.43-6.43,6.43a1.819,1.819,0,1,0,2.572,2.572l6.43-6.43,6.43,6.43a1.819,1.819,0,1,0,2.572-2.572l-6.43-6.43,6.43-6.43A1.819,1.819,0,1,0,22.722,7.29l-6.43,6.43L9.862,7.29A1.819,1.819,0,0,0,7.29,7.29Z",
    transform: "translate(892.912 470.912)",
    fill: "#e3393c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitReject);
export default __webpack_public_path__ + "static/media/visitReject.2f79b4b96e438caa7a6ed6336cd600af.svg";
export { ForwardRef as ReactComponent };